import { BOOKING_PANELS } from '../bookings/BookingDetail';
import { PaymentsPanel } from './PaymentsPanel';

BOOKING_PANELS.push(PaymentsPanel);
